
export default {
  props: {
    options: {type: Array, required: true},
    skip: {type: Object, required: false, default: undefined},
    disabled: {type: Boolean, required: true}
  },
  emits: ['prompt'],
  data() {
    return {
      selected: undefined,
    }
  },
  computed: {
    confirm_disabled() {
      if (this.disabled) return true
      if (!this.has_selection) return true
      return false
    },
    has_selection() {
      return this.selected !== undefined
    },
    skipped() {
      return !this.has_selection && this.disabled
    }
  },
  methods: {
    onSelect(idx) {
      this.selected = idx
    },
    onAccept(){
      const selection = this.options[this.selected]
      this.$emit('prompt', {
        title: selection.chat_query.title || selection.chat_query.text || selection.title,
        selected: [selection.chat_query]
      })
    },
    onSkip() {
      this.selected = undefined
      this.$emit('prompt', this.skip.chat_query)
    }
  }
}
